import './App.css';
import React, { useState } from "react";
import LandscapeImage from './img/landscape-bg.png';
import { Menu } from './components/menu.jsx';
import { About } from './components/about.jsx';
import { Technologies } from './components/technologies.jsx';
import { BottomButtons } from './components/bottom.jsx';
import { Skills } from './components/skills.jsx';
import { Projects } from './components/projects.jsx';
import { Contact } from './components/contact.jsx';

function App() {

  const [content, setContent] = useState("about");

	const handleContentChange = (newContent) => {
		setContent(newContent);
	};

	const getContent = () => {
		switch (content) {
		case "about":
			return <About />;
		case "technologies":
			return <Technologies />;
		case "skills":
			return <Skills />;
		case "projects":
			return <Projects />;
		case "contact":
			return <Contact />;
		default:
			return <About />;
		}
	};

  return (
    <div className="App">
      <div className="vh-100" id="principal" style={{ backgroundImage: `url(${LandscapeImage})` }}>
        <Menu handleContentChange={handleContentChange}/>
        <div className="content">
          {getContent()}
        </div>
        <BottomButtons />
      </div>
    </div>
  );
}

export default App;



